var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1848 15.159L22.3694 10.5889L7.57369 0.564209L0.549453 20.1714C-0.0483541 21.793 0.549453 23.7095 2.19342 24.7415L3.83739 25.7734C4.4352 26.2157 5.18246 26.3631 5.92972 26.3631C6.97588 26.3631 8.02204 25.9209 8.91875 25.0363L11.1605 22.6776L12.3561 23.8569C12.8045 24.2992 13.5518 24.5941 14.1496 24.5941H14.299C15.0463 24.5941 15.6441 24.2992 16.2419 23.7095L19.6793 20.024C20.7254 18.992 20.576 17.2229 19.5298 16.3384L18.1848 15.159ZM7.27478 23.7095C6.67698 24.2992 5.78026 24.4466 5.18246 24.0044L3.38904 22.9724C2.79123 22.5301 2.49233 21.793 2.79123 21.0559L8.61985 4.10235L18.7826 11.0312L7.27478 23.7095ZM17.8859 18.6972L14.4485 22.3827C14.299 22.5301 14.299 22.5301 14.1496 22.5301C14.1496 22.5301 14.0001 22.5301 13.8507 22.3827L12.655 21.2033L16.6902 16.9281L17.8859 18.1075C18.0353 18.2549 18.0353 18.5497 17.8859 18.6972Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedEvent);
export default __webpack_public_path__ + "static/media/selected-event.0f2a519d5276458111b9f16289e222ae.svg";
export { ForwardRef as ReactComponent };